const ChevronDownIcon = ({ className, ...rest }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 8 9"
      className={className}
      {...rest}
    >
      <path
        fill="currentColor"
        d="M4.007 6.563a.75.75 0 0 1-.509-.195L.618 3.706a.7.7 0 0 1-.161-.216.62.62 0 0 1 .152-.733.7.7 0 0 1 .237-.145.77.77 0 0 1 .79.154l2.371 2.19 2.371-2.19a.75.75 0 0 1 .507-.187.75.75 0 0 1 .503.195c.133.123.209.29.21.464a.64.64 0 0 1-.202.468l-2.88 2.662a.75.75 0 0 1-.509.194"
      ></path>
    </svg>
  );
};

export default ChevronDownIcon;
